import React from "react";
import { cn } from "~/lib/cn";
import { WaveBackground } from "./wave-background";

export interface FullScreenCTAProps {
  className?: string;
  children?: React.ReactNode;
}

export const FullScreenCTA: React.FC<FullScreenCTAProps> = ({
  className,
  children,
}) => {
  return (
    <div
      className={cn(
        "relative w-full h-screen max-h-[2048px] flex items-center justify-center overflow-hidden",
        className,
      )}
    >
      {/* Background */}
      <WaveBackground />

      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-black/10" />

      {/* Content container */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6">
        <div className="backdrop-blur-lg bg-white/80 border border-white/30 rounded-3xl p-8 md:p-12 lg:p-16 shadow-2xl shadow-black/20">
          {children}
        </div>
      </div>
    </div>
  );
};
